/* eslint-disable no-underscore-dangle */
import { LibCategories } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";
import { isCountry } from "src/utils/userSegment";

declare const window: Window & {
  _tvq: {
    push: (args: string[] | [(this: any) => void]) => void;
  };
};

const trackerDomain =
  document.location.protocol === "https:"
    ? "https://collector-25355.tvsquared.com/"
    : "http://collector-25355.tvsquared.com/";

window._tvq = window._tvq || ([] as unknown as typeof window._tvq);
window._tvq.push(["setSiteId", "TV-7245634545-1"]);
window._tvq.push(["setTrackerUrl", `${trackerDomain}tv2track.php`]);

export function loadTVSquared() {
  if (!isCountry(["DE"])) {
    return Promise.resolve(window._tvq);
  }

  return loadScript(
    `${trackerDomain}tv2track.js`,
    [LibCategories.targetingCookies],
    { enableCORS: false }
  ).then(() => window._tvq);
}
